import React from "react";
import ListShift from "../../components/dashboard/shiftList";
import InProgressList from "../../components/dashboard/InProgressList";
import Base from "../base";

function Home({children}){
    return(
        <Base>
            <ListShift />
            <div className="mt-4">
                <InProgressList title="Peritajes en curso" />
            </div>
        </Base>
    );
}

export default Home;